import React, { useState } from "react";
import { useFilters } from "../hooks/index.js";
import "../styles/ExportTasksModal.css";
import { baseBackendURL } from "../helpers/baseUrl.js";

const ExportTasksModal = ({ onClose }) => {
  const [exportType, setExportType] = useState("pending");
  const [isExporting, setIsExporting] = useState(false);
  const { activeSlate, slates } = useFilters();

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const response = await fetch(`${baseBackendURL}/export_tasks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          slate: slates[activeSlate],
          exportType: exportType,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to export tasks");
      }

      const csvContent = await response.text();

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `tasks_${exportType}_${slates[activeSlate]}_${
          new Date().toISOString().split("T")[0]
        }.csv`
      );
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      onClose();
    } catch (error) {
      console.error("Error exporting tasks:", error);
      alert("Failed to export tasks. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="export-modal">
      <h2>Export Tasks</h2>
      <p>
        Choose which tasks you'd like to export for the {slates[activeSlate]}{" "}
        slate:
      </p>

      <div className="export-options">
        <label className="export-option">
          <input
            type="radio"
            name="exportType"
            value="pending"
            checked={exportType === "pending"}
            onChange={(e) => setExportType(e.target.value)}
          />
          <span>Pending Tasks Only</span>
          <small>Export tasks that are not yet completed</small>
        </label>

        <label className="export-option">
          <input
            type="radio"
            name="exportType"
            value="completed"
            checked={exportType === "completed"}
            onChange={(e) => setExportType(e.target.value)}
          />
          <span>Completed Tasks Only</span>
          <small>Export tasks that have been completed</small>
        </label>

        <label className="export-option">
          <input
            type="radio"
            name="exportType"
            value="all"
            checked={exportType === "all"}
            onChange={(e) => setExportType(e.target.value)}
          />
          <span>All Tasks</span>
          <small>Export both pending and completed tasks</small>
        </label>
      </div>

      <div className="export-actions">
        <button
          onClick={onClose}
          className="cancel-button"
          disabled={isExporting}
        >
          Cancel
        </button>
        <button
          onClick={handleExport}
          className="export-button"
          disabled={isExporting}
        >
          {isExporting ? "Exporting..." : "Export CSV"}
        </button>
      </div>
    </div>
  );
};

export default ExportTasksModal;
